module.exports = __webpack_public_path__ + "static/greycliffcf-regularoblique-webfont-ca589efde391dfe724b4b323688f6281.woff2";